import { BASE_ACTIONS, SAGA_ACTIONS } from './NDFL3SagaActionTypes';

export const getTaxDeductionOwnerCodes = (year) => {
  return {
    type: BASE_ACTIONS.GET_TAX_DEDUCTION_OWNER_CODES.name + '.REQUEST_START',
    payload: { year },
  };
};

export const getActionTypesForLawyersIncome = () => {
  return {
    type: BASE_ACTIONS.GET_ACION_TYPES_FOR_LAWYERS_INCOME.name + '.REQUEST_START',
    payload: {},
  };
};
export const getDeductionsTaxTypesList = (year) => {
  return {
    type: BASE_ACTIONS.GET_DEDUCTIONS_TAX_TYPES.name + '.REQUEST_START',
    payload: year,
  };
};
export const getTaxPayerCategoriesAction = (year) => {
  return {
    type: BASE_ACTIONS.GET_TAX_PAYER_CATEGORIES.name + '.REQUEST_START',
    payload: year,
  };
};
export const getIncomeTaxTypes = (year) => {
  return {
    type: BASE_ACTIONS.GET_INCOME_TAX_TYPES.name + '.REQUEST_START',
    payload: year,
  };
};
export const getChildDeductions = (data, year) => {
  return {
    type: BASE_ACTIONS.GET_CHILD_DEDUCTIONS.name + '.REQUEST_START',
    payload: { ...data, year },
  };
};
export const saveAndGoNextStepAction = (isDeclarationSubmitStep = false) => {
  return {
    type: SAGA_ACTIONS.SAVE_AND_GO_NEXT,
    payload: { isDeclarationSubmitStep },
  };
};
export const save3NDFLAttaches = (data) => {
  return {
    type: SAGA_ACTIONS.SAVE_NDFL3_DRAFT_ATTACHES,
    payload: data,
  };
};

export const save3NDFLAttachesSuccess = () => {
  return {
    type: SAGA_ACTIONS.SAVE_NDFL3_DRAFT_ATTACHES_SUCCESS,
  };
};

export const save3NDFLAttachesError = () => {
  return {
    type: SAGA_ACTIONS.SAVE_NDFL3_DRAFT_ATTACHES_ERROR,
  };
};

/**
 * used to show child tabs, spoilers that submit button was pressed
 * @returns {{type: string}}
 */
export const setNdfl3SubmitFailAction = () => {
  return {
    type: SAGA_ACTIONS.SET_NDFL3_SUBMIT_FAIL,
  };
};
export const init3NDFLPage = () => {
  return {
    type: SAGA_ACTIONS.INIT_NDFL3_PAGE,
  };
};

export function goPrevStep() {
  return {
    type: SAGA_ACTIONS.GO_PREV_STEP,
  };
}

export function loadingFinish() {
  return {
    type: SAGA_ACTIONS.LOADING_FINISH,
  };
}

export function loadingStart() {
  return {
    type: SAGA_ACTIONS.LOADING_START,
  };
}

export function loadingFromNDFL2Start() {
  return {
    type: SAGA_ACTIONS.LOADING_NDFL2_START,
  };
}

export function loadingFromNDFL2Finish() {
  return {
    type: SAGA_ACTIONS.LOADING_NDFL2_FINISH,
  };
}

export function updateIncomeRates(index, date, currency) {
  return {
    type: SAGA_ACTIONS.UPDATE_INCOME_RATES,
    payload: {
      index,
      date,
      currency,
    },
  };
}

export function updateTaxPaymentRates(index, date, currency) {
  return {
    type: SAGA_ACTIONS.UPDATE_TAX_PAYMENT_RATES,
    payload: {
      index,
      date,
      currency,
    },
  };
}

export function getIncomeSourceBy2ndflId(id, name) {
  return {
    type: SAGA_ACTIONS.GET_INCOME_BY_NDFL2_ID,
    payload: { id, name },
  };
}

export function save3NDFLDraftAndExitAction(blockLocation) {
  return {
    type: SAGA_ACTIONS.SAVE_AND_EXIT,
    payload: { blockLocation },
  };
}

export function goToStep(stepIndex) {
  return {
    type: SAGA_ACTIONS.GO_TO_STEP,
    payload: { stepIndex },
  };
}

export const calculateSumsSection = (incomeSourceIndex) => {
  return {
    type: SAGA_ACTIONS.CALCULATE_SUMS_SECTION,
    payload: { incomeSourceIndex },
  };
};

export const calculateDeduction = (params) => {
  return {
    type: SAGA_ACTIONS.CALCULATE_DEDUCTION,
    payload: params,
  };
};

export function getMonthIncomes(selected) {
  return {
    type: SAGA_ACTIONS.GET_MONTH_INCOMES,
    payload: { selected },
  };
}

export const updateAllDependentFields = (fieldsArray) => {
  return {
    type: SAGA_ACTIONS.UPDATE_ALL_DEPENDENT_GAME_DEDUCTION_FIELDS,
    payload: fieldsArray,
  };
};

export const updateReceiptsList = () => {
  return {
    type: SAGA_ACTIONS.UPDATE_RECEIPTS_LIST,
  };
};

export const updateCalculatedDeductionsByIncomeTypeCode = (payload) => {
  return {
    type: SAGA_ACTIONS.UPDATE_CALCULATED_DEDUCTIONS_BY_INCOME_TYPE_CODE,
    payload,
  };
};

export const initializeOverpaymentsDisposal = (payload) => {
  return {
    type: SAGA_ACTIONS.INITIALIZE_OVERPAYMENTS_DISPOSAL,
    payload,
  };
};
export const initializeOverpaymentsDisposalSuccess = (payload) => {
  return {
    type: SAGA_ACTIONS.INITIALIZE_OVERPAYMENTS_DISPOSAL,
    payload,
  };
};
export const initializeOverpaymentsDisposalFailure = (payload) => {
  return {
    type: SAGA_ACTIONS.INITIALIZE_OVERPAYMENTS_DISPOSAL,
    payload,
  };
};
